export default "__VITE_ASSET__aD42beea__"